export default __webpack_public_path__ + "static/media/helpful-resources-page--mobile.4dca23b3.webp";